import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'cnc-calculator-counter',
  templateUrl: './calculator-counter.component.html',
  styleUrls: ['./calculator-counter.component.scss'],
})
export class CalculatorCounterComponent {
  display :string = '';
  equation = ''; // Add the equation property
  currentOperand :string = '';
  previousOperand :string = '';
  currentTotal :number = 0;
  operation :string | null = null;
  savedResults :number[] = [];
  repeatOperation :{ operation :string; operand :number } | null = null;
  @Output() totalUpdated :EventEmitter<number> = new EventEmitter();

  appendNumber(number :number) :void {
    if (number === 0 && this.display === '0') {
      return;
    }
    if (this.display === '0') {
      this.display = '';
    }
    this.display += number.toString();
    this.equation += number.toString();
  }

  appendDot() :void {
    if (this.display.includes('.')) {
      return;
    }
    this.display += '.';
    this.equation += '.';
  }

  clear() :void {
    this.display = '';
    this.equation = '';
    this.currentOperand = '';
    this.previousOperand = '';
    this.operation = null;
  }

  selectOperation(operation :string) :void {
    if (this.display === '') {
      return;
    }
    if (this.previousOperand !== '') {
      this.calculate();
    }
    this.operation = operation;
    this.previousOperand = this.display;
    this.display = '';
    this.equation += ` ${operation} `;
  }
  equals() :void {
    if (this.display === '') {
      return;
    }
    const currentOperand = parseFloat(this.display);

    if (this.previousOperand === '' && this.repeatOperation) {
      this.operation = this.repeatOperation.operation;
      this.previousOperand = this.display;
      this.display = this.repeatOperation.operand.toString();
      this.calculate();
      this.previousOperand = '';
    } else if (this.previousOperand !== '') {
      this.repeatOperation = {
        operation: this.operation as string,
        operand: currentOperand,
      };
      this.calculate();
      // Update the repeatOperation property after the calculation
      this.equation = ` ${this.display} `;
      this.previousOperand = '';
    }
  }

  calculate() :void {
    const prev = parseFloat(this.previousOperand);
    const current = parseFloat(this.display);
    if (isNaN(prev) || isNaN(current)) {
      return;
    }

    let result :number;

    switch (this.operation) {
      case '+':
        result = prev + current;
        break;
      case '-':
        result = prev - current;
        break;
      case '*':
        result = prev * current;
        break;
      case '/':
        result = prev / current;
        break;
      default:
        return;
    }
    // Round the result so we don't run into any floating point errors
    result = Math.round(result * 100) / 100;
    this.currentOperand = result.toString();
    this.display = this.currentOperand;
    this.previousOperand = this.currentOperand;
  }

  saveResult() :void {
    const result = parseFloat(this.display);
    if (!isNaN(result)) {
      this.savedResults.push(result);
      this.clear();
      this.totalUpdated.emit(this.getTotal());
    }
  }

  deleteResult(index :number) :void {
    this.savedResults.splice(index, 1);
    this.totalUpdated.emit(this.getTotal());
  }

  getTotal() :number {
    return this.savedResults.reduce(
      (total, currentValue) => total + currentValue,
      0,
    );
  }
}
